import { CONNECTIVITY_ITEMS, ASSET, CONSULTATION } from "@/constants/testIds";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ConsultationForm from "@/components/ConsultationForm";

export default function Connectivity() {
  return (
    <div>
      <section className="relative min-h-[60vh] bg-void overflow-hidden flex items-end">
        <img
          src={ASSET.cSector}
          alt="The C-Sector approach road at Chapter III, golden hour"
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-black/10" />
        <div className="relative container-editorial px-5 md:px-10 pt-32 pb-16 md:pb-20">
          <div className="max-w-3xl fade-up">
            <div className="eyebrow text-lime mb-4">
              <span className="editorial-rule bg-lime" /> Connectivity
            </div>
            <h1 className="font-display text-white text-5xl md:text-7xl leading-[0.98]">
              The map is being<br />rewritten around Pali.
            </h1>
            <p className="mt-6 text-cream/85 max-w-xl leading-relaxed">
              Mumbai 3.0, the Missing Link, the Navi Mumbai International Airport, and the Ashtavinayak
              corridor. Four separate infrastructure stories that meet, on the
              ground, at the same place.
            </p>
          </div>
        </div>
      </section>

      {/* Vertical Timeline */}
      <section className="section-pad bg-offwhite">
        <div className="container-editorial px-5 md:px-10 grid md:grid-cols-12 gap-10">
          <aside className="md:col-span-3">
            <div className="eyebrow text-teal mb-3"><span className="editorial-rule" /> The Roadmap</div>
            <h2 className="font-display text-forest text-3xl md:text-4xl leading-tight">
              Five infrastructure moves.<br />One quiet middle.
            </h2>
          </aside>

          <div className="md:col-span-9 relative">
            <div className="absolute left-3 md:left-5 top-1 bottom-1 w-px bg-forest/20" aria-hidden />
            <ol className="space-y-10">
              {CONNECTIVITY_ITEMS.map((c, i) => (
                <li key={c.title} className="relative pl-10 md:pl-16">
                  <span className="absolute left-0 md:left-2 top-1 w-6 h-6 rounded-full bg-lime border-2 border-forest grid place-items-center text-void text-xs font-bold">
                    {i + 1}
                  </span>
                  <div className="eyebrow text-teal">{c.tag} · {c.time}</div>
                  <h3 className="font-display text-forest text-2xl md:text-3xl mt-2 leading-tight">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-forest/75 text-[15px] leading-relaxed max-w-2xl">
                    {c.body}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>

      {/* Distance strip */}
      <section className="bg-forest text-cream py-16 md:py-24">
        <div className="container-editorial px-5 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { v: "2 hrs", l: "Mumbai · Baner · Hinjawadi" },
            { v: "45 min", l: "From Mumbai-Pune Expressway" },
            { v: "1.5 hrs", l: "To Navi Mumbai Int'l Airport" },
            { v: "5 min", l: "To Ashtavinayak Temple" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-display text-4xl md:text-6xl leading-none">{s.v}</div>
              <div className="eyebrow text-cream/60 mt-3">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Inline consultation */}
      <section className="section-pad bg-offwhite">
        <div className="container-editorial grid md:grid-cols-2 gap-10 items-start">
          <div>
            <div className="eyebrow text-teal mb-4"><span className="editorial-rule" /> Online Consultation</div>
            <h2 className="font-display text-forest text-4xl md:text-5xl leading-tight">
              Understand the corridor<br />before you drive it.
            </h2>
            <p className="mt-6 text-forest/70 max-w-md leading-relaxed">
              A free {CONSULTATION.duration}-minute Google Meet with a senior
              advisor. We walk through the Mumbai 3.0 map, Navi Mumbai International Airport timeline, and
              how the Missing Link changes your Sunday drive.
            </p>
            <Link to="/contact" className="mt-6 inline-flex items-center gap-2 text-forest text-sm underline underline-offset-4">
              Or book a physical site visit <ArrowRight size={16} />
            </Link>
          </div>
          <div className="bg-white rounded-lg p-6 md:p-8 border border-forest/10">
            <div className="eyebrow text-teal">Free · Google Meet · 30 min</div>
            <h3 className="font-display text-forest text-2xl mt-1 mb-4">Book my consultation</h3>
            <ConsultationForm source="connectivity_page" ctaLabel="Book my consultation" compact />
          </div>
        </div>
      </section>
    </div>
  );
}
